import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ROOM_STREAM_FEATURE_KEY, RoomStreamState } from "../reducers";

export const state = createFeatureSelector<RoomStreamState>(
  ROOM_STREAM_FEATURE_KEY
);

export const isLoading = createSelector(
  state,
  (state: RoomStreamState) => state.isLoading
);
